import { render, staticRenderFns } from "./NonLoginBusinessMatch.vue?vue&type=template&id=0764f1ce&scoped=true"
import script from "./NonLoginBusinessMatch.vue?vue&type=script&lang=ts"
export * from "./NonLoginBusinessMatch.vue?vue&type=script&lang=ts"
import style0 from "./NonLoginBusinessMatch.vue?vue&type=style&index=0&id=0764f1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764f1ce",
  null
  
)

export default component.exports